import { datadogRum } from '@datadog/browser-rum';
import { Amplify } from 'aws-amplify';

import amplifyConfig from 'aws-exports';
import { useGetTextInSelectLanguaje } from 'hooks/useGetTextInSelectLanguaje';
import { AppRoutes } from 'routes/AppRoutes';
import { useAppSelector } from 'store/hooks';
import { selectLanguageCode } from 'store/translation/translation.slice';
amplifyConfig.oauth.redirectSignIn = `${window.location.origin}/admin`;
amplifyConfig.oauth.redirectSignOut = `${window.location.origin}/admin`;
Amplify.configure(amplifyConfig);

datadogRum.init({
  applicationId: 'ef37edea-fdff-4f1b-bcd9-8318ac7f5de9',
  clientToken: 'pub9245efe3a3e93ae83ffbda86adad5ee3',
  // site refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'datadoghq.com',
  service: 'pragma-rum-plataforma-de-ingreso',
  env: 'dev',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'allow',
});

const App = () => {
  const languageCode = useAppSelector(selectLanguageCode);
  const { isError } = useGetTextInSelectLanguaje(languageCode);

  return (
    <div className='app'>
      <AppRoutes />
    </div>
  );
};

export default App;
